import { Emitter } from '@/core/Emitter';

export const emitter = new Emitter();
